import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const TagList = forwardRef(function TagList(
  { tags = [], className },
  ref,
) {
  const normalizedTags = (Array.isArray(tags) ? tags : [])
    .map((tag) => {
      if (typeof tag === 'string') {
        return { name: tag, key: tag };
      }

      if (tag && typeof tag === 'object' && tag.tag_name) {
        return {
          name: tag.tag_name,
          key: tag.tag_id ?? tag.tag_name,
        };
      }

      return null;
    })
    .filter(Boolean);

  return (
    <div
      ref={ref}
      className={['tags-list', className].filter(Boolean).join(' ')}
    >
      {normalizedTags.map((tag) => (
        <Link
          key={tag.key}
          to={`/tag/${encodeURIComponent(tag.name)}`}
          className="tag tag-small"
          title={tag.name}
        >
          <span className="tag-symbol">#</span>
          <span className="tag-text">{tag.name}</span>
        </Link>
      ))}
    </div>
  );
});

export default TagList;

